import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
	selector: '[loading]'
})
export class LoadingDirective {
	@HostBinding('class.loading') @Input() loading: boolean = false;
}
